import { Turbo } from "@hotwired/turbo-rails";

function initCheckWithMedia() {
  const checkBox = document.getElementById("with_media");
  if (!checkBox) return;

  updateStatus();
  checkBox.addEventListener("input", updateStatus);

  function updateStatus() {
    Turbo.cache.clear();

    if (checkBox.checked) {
      document.body.classList.add("show-with-media");
      document.body.classList.remove("show-without-media");
    } else {
      document.body.classList.remove("show-with-media");
      document.body.classList.add("show-without-media");
    }
  }
}
document.addEventListener("turbo:frame-load", initCheckWithMedia);
document.addEventListener("turbo:load", initCheckWithMedia);
